import { httpClient } from 'repositories/HttpClientRepository';
import { sessionStore } from 'store/Session';
import HeaderDecorator from './HeaderDecorator';

export const headerDataHttpClient = new HeaderDecorator(sessionStore, httpClient);
export type { IHeaderDecorator } from './interfaces/IHeaderDecorator';
